import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=32f06eac&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=js&"
export * from "./EmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=32f06eac&prod&lang=sass&scoped=true&"
import style1 from "./EmojiPicker.vue?vue&type=style&index=1&id=32f06eac&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f06eac",
  null
  
)

export default component.exports